interface Props {
  text: string
  onClick: () => void
}

export const SpeedRateLabel: React.FC<Props> = ({ text, onClick }) => {
  return (
    <div
      className="inline-block relative z-0 mr-[3px] w-20 h-[30px] bg-transparent rounded-[30px] border-2 border-[#008cdb] border-solid select-none"
      onClick={onClick}
    >
      <div className="block w-20 text-[11px] font-medium leading-[30px] bg-transparent rounded-[30px] border-none shadow-none appearance-none cursor-pointer">
        {text}
      </div>
    </div>
  )
}
